import React from 'react';
import cn from 'classnames';

interface ShowMoreButtonInterface {
  onClick(e): void;
  isOpen: boolean;
}

function ShowMoreButton(props: ShowMoreButtonInterface): JSX.Element {
  const { onClick, isOpen } = props;
  const classNames = cn('About_ShowMore', {
    About_ShowMore_opened: isOpen,
  });
  return (
    <i
      className={classNames}
      onKeyPress={() => onClick(isOpen)}
      onClick={() => onClick(isOpen)}
      role="button"
      tabIndex={0}
    />
  );
}

export default ShowMoreButton;
